const { addAction, doAction } = sitchco.hooks;

const COMPONENT = 'ui-modal';
const SHOW_MODAL_HOOK = `${COMPONENT}-show`;
const HIDE_MODAL_HOOK = `${COMPONENT}-hide`;
const ENABLE_DISMISS_HOOK = `${COMPONENT}-enableDismiss`;

const showModal = (modal) => doAction(SHOW_MODAL_HOOK, modal);
const hideModal = (modal) => doAction(HIDE_MODAL_HOOK, modal);

const setModalLabel = (modal) => {
    const labelId = `${modal.id}-label`;
    const heading = modal.querySelector('h1, h2, h3, h4, h5, h6');
    if (!heading) {
        return;
    }

    heading.id = labelId;
    modal.setAttribute('aria-labelledby', heading.id);
};

const getTriggersForModal = (modal) => {
    return modal.id ? document.querySelectorAll(`a[href="#${modal.id}"], [data-target="#${modal.id}"]`) : [];
};

const getTriggerTarget = (trigger) => {
    const href = trigger.getAttribute('href');
    const dataTarget = trigger.dataset.target;
    const selector = dataTarget || href;
    return selector ? document.querySelector(selector) : null;
};

addAction(
    SHOW_MODAL_HOOK,
    (modal) => {
        if (modal.hasAttribute('open')) {
            return;
        }

        // Close any already-open modal before opening a new one
        const currentModal = document.querySelector('dialog.sitchco-modal[open]');
        if (currentModal && currentModal !== modal) {
            hideModal(currentModal);
        }

        setModalLabel(modal);
        getTriggersForModal(modal).forEach((el) => el.setAttribute('aria-expanded', 'true'));

        document.body.classList.add('lock-scroll');
        modal.showModal();
        modal.scrollTop = 0;

        if (modal.id && sitchco.hashState.get().current !== modal.id) {
            sitchco.hashState.set(modal.id);
        }
    },
    10,
    COMPONENT
);

addAction(HIDE_MODAL_HOOK, (modal) => modal.close(), 10, COMPONENT);

addAction(
    ENABLE_DISMISS_HOOK,
    (modal) => {
        const el = modal || document.querySelector('dialog.sitchco-modal[open].sitchco-modal--blockdismiss');
        if (el) {
            el.classList.remove('sitchco-modal--blockdismiss');
        }
    },
    10,
    COMPONENT
);

// React to centralized hash state changes (open/close modals by hash)
addAction(
    sitchco.constants.HASH_STATE_CHANGE,
    (state) => {
        const openModal = document.querySelector('dialog.sitchco-modal[open]');
        if (openModal && openModal.id !== state.current) {
            hideModal(openModal);
        }
        if (!state.isset()) {
            return;
        }

        const modal = document.querySelector(`dialog.sitchco-modal#${CSS.escape(state.current)}`);
        if (modal && !modal.hasAttribute('open')) {
            showModal(modal);
        }
    },
    10,
    COMPONENT
);

document.addEventListener('DOMContentLoaded', function () {
    // Set up cancel/close event listeners on each dialog
    document.querySelectorAll('dialog.sitchco-modal').forEach((modal) => {
        // Route Escape-key close through hideModal() so the ui-modal-hide hook fires
        modal.addEventListener('cancel', (e) => {
            e.preventDefault();

            if (!modal.classList.contains('sitchco-modal--blockdismiss')) {
                hideModal(modal);
            }
        });

        // Clean up on close — runs for both programmatic modal.close() and browser Escape
        modal.addEventListener('close', () => {
            document.body.classList.remove('lock-scroll');
            getTriggersForModal(modal).forEach((el) => el.setAttribute('aria-expanded', 'false'));

            if (modal.id && sitchco.hashState.get().current === modal.id) {
                sitchco.hashState.clear();
            }
        });
    });

    // Mark trigger elements and add ARIA attributes
    document.querySelectorAll('dialog.sitchco-modal').forEach((modal) => {
        const id = modal.id;
        if (!id) {
            return;
        }

        getTriggersForModal(modal).forEach((el) => {
            el.classList.add('js-modal-trigger');
            el.setAttribute('aria-haspopup', 'dialog');
            el.setAttribute('aria-expanded', 'false');

            const tag = el.tagName.toLowerCase();
            if (tag !== 'a' && tag !== 'button') {
                if (!el.getAttribute('role')) {
                    el.setAttribute('role', 'button');
                }
                if (!el.getAttribute('tabindex')) {
                    el.setAttribute('tabindex', '0');
                }
            }
        });
    });

    // Trigger click
    document.body.addEventListener('click', (e) => {
        const trigger = e.target.closest('.js-modal-trigger');
        if (!trigger) {
            return;
        }

        e.preventDefault();
        const target = getTriggerTarget(trigger);
        if (target) {
            trigger.focus(); // ensure native dialog saves the right element for focus restoration
            showModal(target);
        }
    });

    // Trigger keyboard activation for non-interactive elements
    document.body.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') {
            return;
        }

        const trigger = e.target.closest('.js-modal-trigger');
        if (!trigger) {
            return;
        }

        const tag = trigger.tagName.toLowerCase();
        if (tag === 'a' || tag === 'button') {
            return; // native elements handle this themselves
        }

        e.preventDefault();
        const target = getTriggerTarget(trigger);
        if (target) {
            showModal(target);
        }
    });

    // Modal dismiss click (backdrop or close button)
    document.body.addEventListener('click', (e) => {
        const modal = e.target.closest('dialog.sitchco-modal');
        if (!modal || modal.classList.contains('sitchco-modal--blockdismiss')) {
            return;
        }

        const target = e.target;
        if (target === modal || target.closest('.sitchco-modal__close') || target.closest('.js-modal-close')) {
            hideModal(modal);
        }
    });
});
